import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import SpaCarosle from "../../Components/SpaCarosle";
import axios from "../../axios";
import Green from "../../assets/images/icons/green-leaf.png";
import { Button } from "react-bootstrap";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import "../../new-pages/hotel-services/HotelServices.scss";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import { Accordion, AccordionTab } from "primereact/accordion";
import Title from "../../new-components/title/Title";
import BannerServices from "../../new-components/banner-home/BannerServices";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
import Sar from "../../assets/images/icons/Sar";

function PantryRefill() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  const [service, setService] = useState([]);
  const [showError, setShowError] = useState(false);
  const [loading, setLaoding] = useState(false);
  const [title, setTitle] = useState();
  const [pantryServices, setPantryServices] = useState();
  const [headerImages, setHeaderImages] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);

  const toggleService = (input, name, working_times) => {
    if (service.includes(input)) {
      ReactGA.event({
        category: "Add Pantry Refill",
        action: "Click",
        value: `Pantry Refill: ${name}`,
      });
      setService((prev) => prev.filter((x) => x !== input));
    } else {
      setService((prev) => [...prev, input]);
    }
  };

  const lang = sessionStorage.getItem("lang");
  const currency = localStorage.getItem("currency");

  const handleBook = async () => {
    if (service.length <= 0) {
      setShowError(true);
      return;
    }

    setIsDisabled(true);

    const payload = {
      services: service,
    };

    try {
      const res = await axios.post(
        `/${room_uuid}/pantry-refill/book-service`,
        payload,
        {
          headers: { lang },
        },
      );

      setIsDisabled(false);
      if (res?.data?.status) {
        navigate(`/${room_uuid}/PantryRefillOrderPlaced`);
      }
    } catch (firstErr) {
      try {
        const res = await axios.post(
          `/${room_uuid}/pantry-refill/book-service`,
          payload,
          {
            headers: { lang },
          },
        );

        setIsDisabled(false);
        if (res?.data?.status) {
          navigate(`/${room_uuid}/PantryRefillOrderPlaced`);
        }
      } catch (err) {
        setIsDisabled(false);
        console.log(err || firstErr);
      }
    }
  };

  useEffect(() => {
    const getData = async () => {
      setLaoding(true);

      try {
        const res = await axios.get(`/${room_uuid}/pantry_refill`, {
          headers: { lang },
        });

        if (res?.data?.status === false) {
          navigate(`/${room_uuid}/qr-scan`);
        } else {
          const data = res?.data?.data;
          setPantryServices(
            data?.pantryRefillServices ||
              data?.pantry_refill_services ||
              data?.houseKeepingServices,
          );
          setTitle(data?.title || "Pantry Refill");
          setHeaderImages(data?.banners);
        }
      } catch (firstErr) {
        try {
          const res = await axios.get(`/${room_uuid}/pantry-refill`, {
            headers: { lang },
          });

          if (res?.data?.status === false) {
            navigate(`/${room_uuid}/qr-scan`);
          } else {
            const data = res?.data?.data;
            setPantryServices(
              data?.pantryRefillServices ||
                data?.pantry_refill_services ||
                data?.houseKeepingServices,
            );
            setTitle(data?.title || "Pantry Refill");
            setHeaderImages(data?.banners);
          }
        } catch (err) {
          if (
            err?.response?.status == 404 ||
            firstErr?.response?.status == 404
          ) {
            navigate(`/not-found`);
          }
        }
      }

      setLaoding(false);
    };

    getData();
  }, []);

  return (
    <div className={theme ? "food pb-0" : ""}>
      {theme ? <Title title={title} /> : <HeaderInner headerName={title} />}
      <main className="home-main bg-white back-white pad-top-0 house">
        {loading ? (
          <SpaLoader />
        ) : (
          <>
            {theme ? (
              <BannerServices headerImages={headerImages} />
            ) : (
              <SpaCarosle
                noDots={true}
                autoPlay={true}
                isSalon={true}
                salonImg={headerImages}
              />
            )}

            <div className="housekeeping-container">
              <p className="service">{t("Choose a Service")}</p>
              <div className="service-container">
                {pantryServices &&
                  pantryServices.map((prop) => {
                    const {
                      id,
                      name,
                      is_green,
                      activeSubCategories,
                      price,
                      description,
                      working_times,
                    } = prop;

                    return (
                      <React.Fragment key={id || name}>
                        {activeSubCategories?.length > 0 ? (
                          <>
                            <Accordion
                              multiple
                              expandIcon="fa fa-plus"
                              collapseIcon="fa fa-minus"
                              className="mb-3 acor_house"
                            >
                              <AccordionTab
                                key={"PantryRefill"}
                                header={
                                  <>
                                    <span>{name}</span>
                                    {price != 0 && (
                                      <span className="house_price">
                                        {price}{" "}
                                        {currency === "SAR" ? (
                                          <Sar color="currentcolor" />
                                        ) : (
                                          `${currency} `
                                        )}
                                      </span>
                                    )}
                                  </>
                                }
                                disabled={false}
                              >
                                {activeSubCategories?.map((item) => {
                                  return (
                                    <Button
                                      key={item.id}
                                      className={
                                        service.includes(item.id)
                                          ? `reg-btn outline-btn dark d-flex justify-content-center  ${
                                              item.is_green == 1
                                                ? "is_green"
                                                : ""
                                            }`
                                          : "reg-btn outline-btn d-flex justify-content-center "
                                      }
                                      onClick={() =>
                                        toggleService(
                                          item.id,
                                          item.name,
                                          working_times,
                                        )
                                      }
                                    >
                                      <span>{item.name}</span>
                                      {item?.price != 0 && (
                                        <span className="house_price">
                                          {item?.price}{" "}
                                          {currency === "SAR" ? (
                                            <Sar color="currentcolor" />
                                          ) : (
                                            `${currency} `
                                          )}
                                        </span>
                                      )}
                                      {item.is_green == 1 && (
                                        <img
                                          className="green_img"
                                          src={Green}
                                          alt=""
                                          width={25}
                                          height={25}
                                        />
                                      )}
                                    </Button>
                                  );
                                })}
                              </AccordionTab>
                            </Accordion>
                            {description && (
                              <p className="desc">{description}</p>
                            )}
                          </>
                        ) : (
                          <>
                            <Button
                              className={
                                service.includes(id)
                                  ? `reg-btn outline-btn dark d-flex justify-content-center  ${
                                      is_green == 1 ? "is_green" : ""
                                    }`
                                  : "reg-btn outline-btn d-flex justify-content-center "
                              }
                              onClick={() =>
                                toggleService(id, name, working_times)
                              }
                            >
                              <span>{name}</span>
                              {price != 0 && (
                                <span className="house_price">
                                  {price}{" "}
                                  {currency === "SAR" ? (
                                    <Sar color="currentcolor" />
                                  ) : (
                                    `${currency} `
                                  )}
                                </span>
                              )}
                              {is_green == 1 && (
                                <img
                                  className="green_img"
                                  src={Green}
                                  alt=""
                                  width={25}
                                  height={25}
                                />
                              )}
                            </Button>
                            {description && (
                              <p className="desc">{description}</p>
                            )}
                          </>
                        )}
                      </React.Fragment>
                    );
                  })}
              </div>

              {showError ? (
                <p className="no-service">{t("Choose a service")}</p>
              ) : null}

              <div className="book">
                <Button
                  onClick={handleBook}
                  disabled={isDisabled}
                  className="reg-btn"
                >
                  {t("Order")}
                </Button>
              </div>
            </div>
          </>
        )}
      </main>
      {theme && <NewFooter />}
    </div>
  );
}

export default PantryRefill;
